import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Toggle menu on small screens
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Fonction pour faire défiler vers le haut
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Défilement vers le haut
    setIsMenuOpen(false);
  };

  return (
    <header className='header'>
      <div className="header-wrap">
        <div className="logo plain logo-left">
          <div className="site-title">
            <Link to="/" title="Go to Home">Leslieloic.com</Link>
          </div>
        </div>
        <nav id="nav" role="navigation" className={isMenuOpen ? 'menu-open' : ''}>
          <div className="table">
            {/* Hamburger Button for Mobile */}
            <button className="menu-toggle" onClick={toggleMenu}>
              ☰
            </button>
            {/* Navigation */}
            <div className="table-cell">
              <ul id="menu-menu-1" className={isMenuOpen ? 'dropdown-menu' : 'nav-menu'}>
                <li className="menu-item"><Link to="/" onClick={handleLinkClick}>Accueil</Link></li>
                <li className="menu-item"><Link to="/map" onClick={handleLinkClick}>Localisation</Link></li>
                <li className="menu-item"><Link to="/wedding-rsvp" onClick={handleLinkClick}>Confirmer ma présence</Link></li>
                <li className="menu-item"><Link to="/faq" onClick={handleLinkClick}>Faq</Link></li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
